export const ROUTE_HOME_NAME = 'home'
export const ROUTE_STYLE_GUIDE_NAME = 'style-guide'
export const ROUTE_DASHBOARD_SETTINGS_NAME = 'dashboard-settings'
export const ROUTE_LAYOUT_SETTINGS_NAME = 'layout-settings'
export const ROUTE_DASHBOARD_CREATION_NAME = 'dashboard-creation'

export const ROUTE_REPORTS_NAME = 'reports'
export const ROUTE_REPORTS_LIST_NAME = 'reports-list'
export const ROUTE_REPORTS_EDIT_NAME = 'reports-edit'
export const ROUTE_REPORTS_CREATE_NAME = 'reports-create'

export const ROUTE_NOT_FOUND = 'Not Found'

export default [
    {
        path: '/',
        name: ROUTE_HOME_NAME,
        component: () => import('../views/DashboardPage.vue'),
    },
    {
        path: '/style-guide',
        name: ROUTE_STYLE_GUIDE_NAME,
        component: () => import('../views/StyleGuide.vue'),
    },
    {
        path: '/dashboard-settings',
        name: ROUTE_DASHBOARD_SETTINGS_NAME,
        component: () => import('../views/DashboardSettings/DashboardSettings.vue'),
    },
    {
        path: '/dashboard-creation',
        name: ROUTE_DASHBOARD_CREATION_NAME,
        component: () => import('../views/DashboardCreation/DashboardCreation.vue'),
    },
    {
        path: '/reports',
        name: ROUTE_REPORTS_NAME,
        component: () => import('@/modules/reports/ReportsLayout.vue'),
        children: [
            {
                path: '',
                name: ROUTE_REPORTS_LIST_NAME,
                component: () => import('@/modules/reports/pages/RedesignReportList.vue'),
            },
            {
                path: 'edit/:id',
                name: ROUTE_REPORTS_EDIT_NAME,
                component: () => import('@/modules/reports/pages/RedesignReportEdit.vue'),
            },
            {
                path: 'create',
                name: ROUTE_REPORTS_CREATE_NAME,
                component: () => import('@/modules/reports/pages/RedesignReportCreate.vue'),
            },
        ],
    },
    {
        path: '/:pathMatch(.*)*',
        name: ROUTE_NOT_FOUND,
        meta: {
            skipOrganizationCheck: true,
            productionReady: true,
        },
        redirect: '/',
    },
]
